import { createSlice } from "@reduxjs/toolkit";

export const payroleSlice = createSlice({
  name: "payroleReducer",
  initialState: {
    cred: { userId: "", password: "", email: "" },
  },
  reducers: {
    setCred: (state, action) => {
      state.cred = action.payload;
    },
  },
});

export const { setCred } = payroleSlice.actions;
export default payroleSlice.reducer;
